import { Grid, IconButton, Box, useMediaQuery } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import ChevronLeft from "@mui/icons-material/ChevronLeft";
import ChevronRight from "@mui/icons-material/ChevronRight";
import React, { useState } from "react";

function SampleGallery({ images = [], service = "" }) {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const [current, setCurrent] = useState(0);

  if (isMobile) {
    // Mobile: Show one image at a time with paging
    const handlePrev = () => setCurrent((prev) => Math.max(prev - 1, 0));
    const handleNext = () => setCurrent((prev) => Math.min(prev + 1, images.length - 1));

    return (
      <Box display="flex" alignItems="center" justifyContent="center" sx={{ width: "100%", minHeight: "40vw" }}>
        <IconButton onClick={handlePrev} disabled={current === 0}>
          <ChevronLeft />
        </IconButton>
        <Box
          sx={{
            width: "80vw",
            maxWidth: 400,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <img
            src={images[current]}
            alt={`${service} sample ${current + 1}`}
            loading="eager"
            style={{
              width: "100%",
              height: "45vw",
              maxHeight: 350,
              objectFit: "cover",
              borderRadius: "8px",
              display: "block",
            }}
          />
        </Box>
        <IconButton onClick={handleNext} disabled={current === images.length - 1}>
          <ChevronRight />
        </IconButton>
      </Box>
    );
  }

  // Desktop: Show all images in a row (4 at a time)
  return (
    <Grid
      container
      justifyContent="space-between"
      sx={{
        marginLeft: "10%",
        marginRight: "10%",
        display: "flex",
        flexWrap: "nowrap",
        gap: 2, // Replace spacing with explicit gap
      }}
    >
      {images.map((img, idx) => (
        <Grid
          key={`${service} sample ${idx + 1}`}
          sx={{
            flex: "1 1 0",
            maxWidth: "calc((100% - 3 * 16px) / 4)",
            aspectRatio: "4 / 3",
            overflow: "hidden",
            borderRadius: "8px",
          }}
        >
          <Box
            component="img"
            src={img}
            alt={`${service} sample ${idx + 1}`}
            loading="eager"
            sx={{
              width: "100%",
              height: "100%",
              objectFit: "cover",
              display: "block",
            }}
          />
        </Grid>
      ))}
    </Grid>
  );
}

export default SampleGallery;
